// transforms json blocks to HTML elements
const transform = (editorJson) => {
    if (!editorJson && !editorJson.blocks) return null;
    let processed = '';
    editorJson.blocks.forEach(block => {
        // skip incomplete blocks
        if (!block.data) return;

        if (block.type == "header") {
            processed += `<h${block.data.level}>${block.data.text}</h${block.data.level}>`
        }
        else if (block.type == "paragraph") {
            processed += `<p>${block.data.text}</p>`;
        }
        else if (block.type == "list") {
            let html = `<${block.data.style[0]}l>`;
            block.data.items.forEach(li => {
                if (li && li.length) html += `<li>${li}</li>`;
            });
            html += `</${block.data.style[0]}l>`;
            processed += html;
        }
        else if (block.type == "image") {
            processed += `<img src="${block.data.dataUrl}" alt="${block.data.alt}">`;
        }
        else if (block.type == "quote") {
            processed += `<p class="q1"> ${block.data}</p>`;
        }
        else if (block.type == "warning") {
            processed += `
                <p class="w3">${block.data.title}</p>
                <p class="w2">${block.data.subtitle}</p>
                <p class="w1">${block.data.content}</p>
            `;
        }
        else if (block.type == "proTip") {
            processed += `
                <p class="p3">${block.data.title}</p>
                <p class="p2">${block.data.subtitle}</p>
                <p class="p1">${block.data.content}</p>
            `;
        }

        else if (block.type == "table" && block.data.content && block.data.content.length) {
            var html = "<table><thead><tr>";
            block.data.content[0].forEach(th => {
                html += `<th>${th}</th>`;
            });
            html += `</tr></thead><tbody>`;

            // tbody
            for (let i = 1; i < block.data.content.length; i++) {
                const tr = block.data.content[i];
                html += '<tr>';
                for (let j = 0; j < tr.length; j++) {
                    const td = tr[j];
                    html += `<td>${td}</td>`;
                }
                html += "</tr>";
            }
            html += "</tbody></table>"
            processed += html;
        }
        else if (block.type == "featuredPost") {
            processed += `
            <div class="featuredPost">
              <div class="featuredPost">
                <div class="imageContainer"><i class="fad fa-newspaper"></i></div>
              <div class="postDetails">
                <h2>
                  <a href="${block.data.url}">
                    Featured Internal Post
                  </a>
                </h2>

                <a href="${block.data.url}">
                <span class="--text-sm"> (${block.data.url}) </span>
              </a>

                <p> 
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur magna arcu id mauris. 
                  Etiam ex massa, vehicula sed dictum sit amet, condimentum malesuada dui. 
                </p>
              </div>
            </div>            
            `;
        }
        else if (block.type == "featuredProduct") {
            processed += `

            <div class="row justify-content-center pb-3 pb-md-5 mt-5 mt-md-0">
            <div class="col-md-4 px-md-0 px-5">
              <a
                href="${block.data.link}"
                target="_blank"
                ><img
                  src="${block.data.dataUrl}"
                  class="lazyLoad lazyautosizes pb-4 visible"
              /></a>
            </div>
            <div
              class="col-md-8 px-md-5 text-left"
              style="border-top: lightgrey 1px solid"
            >
              <h3 class="lh1-3 py-0 text-left">
                <a
                  href="${block.data.link}"
                  class="heading"
                  target="_blank"
                  >${block.data.title}</a
                >
              </h3>
              <p class="lh1-7 size1-1 pt-1 fw500 mb-0 text-left">
              ${block.data.description}
              </p>
              <p class="lh1-7 size1-1 pt-4 fw500 mb-0 text-left">
                <a
                  target="_blank"
                  href="${block.data.link}"
                  ><img
                    src="https://www.carpetandrugworld.com/assets/img/icons/amazonprime.png"
                    alt="Amazon Prime Logo"
                    class="img-fluid"
                    style="width: 180px"
                    ezimgfmt="rs rscb3 src ng ngcb3"
                /></a>
              </p>
              <a
                target="_blank"
                href="${block.data.link}"
                ><button
                  class="btn btn-resources fw600 mt-3 px-3"
                  style="background-color: #ffa637; color: black; letter-spacing: 0.02rem"
                >
                  Check Price on Amazon
                </button></a
              >
            </div>
          </div>
            `;
        }
        else if (block.type == "code") {
            processed += block.data.html;
        }
    });
    return processed;
}

export const toHtmlPreview = (json) => {
    return transform(json);
}

